import React from "react";
import injectSheet from "react-jss";
import PropTypes from "prop-types";
import { push } from "gatsby-link";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  hiddenItem: {
    textAlign: "left"
    //padding: ${theme.space.xs};
  },
  item: {
    background: "transparent",
    transition: `all ${theme.time.duration.default}`,
    display: "flex",
    alignItems: "center",
    "& button, & a": {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing.S
    },
    "& svg": {
      color: theme.palette.secondary.main,
      margin: `0 ${theme.spacing.XS}px 0 0`
    },
    "&.hideItem": {
      display: "none"
    }
  },
  showItem: {},
  inHiddenItem: {
    color: theme.info.colors.text
  }
});

/*
.item,
.showItem {
  background: transparent;
  transition: all ${theme.time.duration.default};
  display: flex;
  align-items: center;

  :global(a) {
    padding: ${theme.space.inset.s};
    display: flex;
    align-items: center;
  }

  :global(svg) {
    margin: 0 ${theme.space.inset.xs} 0 0;
    opacity: 0.3;
  }
}

:global(.itemList .hideItem) {
  display: none;
}

@from-width desktop {
  .item {
    :global(a) {
      color: ${theme.text.color.primary};
      padding: ${theme.space.inset.s};
      transition: all ${theme.time.duration.default};
      border-radius: ${theme.size.radius.small};
    }

    :global(.homepage):not(.fixed) & :global(a) {
      color: ${theme.color.neutral.white};
    }

    :global(a:hover) {
      color: ${theme.color.brand.primary};
      background: color(white alpha(-60%));
    }

    :global(svg) {
      transition: all ${theme.time.duration.default};
    }

    &:hover :global(svg) {
      fill: ${theme.color.brand.primary};
      opacity: 1;

      :global(.hero) & :global(svg) {
        fill: green;
      }
    }
  }

  .showItem {
    display: none;
  }

  .hiddenItem {
    text-align: left;
    padding: ${theme.space.xs};

    & :global(a.inHiddenItem) {
      color: ${theme.text.color.primary};
      &:hover {
        color: ${theme.color.brand.primary};
      }
    }
  }
}
*/

const Item = props => {
  const { classes, item: { label, to, icon: Icon } = {}, onClick } = props;

  return (
    <React.Fragment>
      <li className={"hiddenItem" in props ? classes.hiddenItem : classes.item} key={label}>
        {onClick ? (
          <Button onClick={onClick} className={"hiddenItem" in props ? classes.inHiddenItem : ""}>
            {Icon && <Icon />} {label}
          </Button>
        ) : (
          <Button
            className={"hiddenItem" in props ? classes.inHiddenItem : ""}
            onClick={() => push(to)}
          >
            {Icon && <Icon />} {label}
          </Button>
        )}
      </li>
    </React.Fragment>
  );
};

Item.propTypes = {
  item: PropTypes.object,
  hidden: PropTypes.bool,
  onClick: PropTypes.func,
  index: PropTypes.number,
  icon: PropTypes.func,
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Item);



// WEBPACK FOOTER //
// ./src/components/Menu/Item.js